import { useMemo } from 'react';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import { CheckboxProps } from './Checkbox.types';
import useCheckboxField from './useCheckboxField';

const usePresenter = (props: CheckboxProps) => {
  const {
    className,
    size = 'Medium',
    type = 'Default',
    checked,
    onValueChange,
    disabled = false,
    invalid = false,
    required,
    labelAlignment = 'Left',
    defaultChecked = false,
    children,
    name,
    value,
    ...otherInputProps
  } = props;

  const { isChecked, onCheckboxChanged } = useCheckboxField({ checked, defaultChecked, value, onValueChange });

  const variantProps = useBuildVariantProps(
    'checkbox',
    {
      styles: isChecked ? 'Selected' : 'Unselected',
      size,
      type,
    },
    {
      disabled,
      invalid,
    },
  );

  return {
    otherInputProps,
    onCheckboxChanged,
    variantProps,
    labelAlignment,
    disabled,
    isChecked,
    required,
    name,
    invalid,
  };
};

export default usePresenter;